import { GroupTree, Category, InvoiceFile } from '../types/invoices';

export const INVOICES_PREFIX = 'invoices';

export const parseDateFromFilename = (name: string): Date | null => {
  const m = name.match(/(\d{2})-(\d{2})-(\d{4})/); // DD-MM-AAAA
  if (!m) return null;
  const [_, dd, mm, yyyy] = m;
  const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
  return isNaN(d.getTime()) ? null : d;
};

export const detectCategory = (name: string): Category =>
  /gift/i.test(name) ? 'gifts' : 'workshops';

export const formatBytes = (bytes?: number) => {
  if (bytes == null) return '—';
  const sizes = ['B', 'KB', 'MB', 'GB'];
  if (bytes === 0) return '0 B';
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    sizes.length - 1
  );
  return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 2)} ${sizes[i]}`;
};

export const formatDateFR = (d?: Date | null) =>
  d
    ? d.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
    : '—';

export const monthLabel = (mm: string) => {
  const monthName = new Date(2000, Number(mm) - 1, 1).toLocaleDateString(
    'fr-FR',
    {
      month: 'long',
    }
  );
  return `${mm} - ${monthName.charAt(0).toUpperCase()}${monthName.slice(1)}`;
};

export const buildGroups = (files: InvoiceFile[]): GroupTree => {
  const byCat: GroupTree = { gifts: {}, workshops: {} };
  for (const f of files) {
    const cat = f.category;
    const y = f.year ?? 'unknown';
    const m = f.month ?? 'unknown';
    byCat[cat][y] ??= {};
    byCat[cat][y][m] ??= [];
    byCat[cat][y][m].push(f);
  }
  // tri interne récent → ancien
  for (const cat of Object.keys(byCat) as Category[]) {
    for (const y of Object.keys(byCat[cat])) {
      for (const m of Object.keys(byCat[cat][y])) {
        byCat[cat][y][m].sort((a, b) => {
          const ad = a.dateFromName ?? a.updated ?? new Date(0);
          const bd = b.dateFromName ?? b.updated ?? new Date(0);
          return bd.getTime() - ad.getTime();
        });
      }
    }
  }
  return byCat;
};
